exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.location-delete[data-v-2a217fe9] {\n  /* Component styles */\n}\n", ""]);

// exports
